import { track, trackPageview } from "../lib/analytics"

// Initial load, plus every Turbo navigation (the player layout has no Turbo, so
// there only the first call fires). trackPageview() dedupes by URL, so the
// overlap between the two on first load is harmless.
trackPageview()
document.addEventListener("turbo:load", trackPageview)

// Links and buttons can name an explicit event (doc 07 §9):
// data-analytics-event="Payroll PDF Downloaded" data-analytics-props='{"kind":"preview"}'
document.addEventListener("click", (event) => {
  const el = event.target.closest?.("[data-analytics-event]")
  if (!el) return
  let props = {}
  try {
    props = JSON.parse(el.dataset.analyticsProps || "{}")
  } catch {
    props = {}
  }
  track(el.dataset.analyticsEvent, props)
})
